import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

import getEnvironDomain from 'utils/getEnvironDomain';
import setUrlParameter from 'utils/setUrlParameter';
import deleteUrlParameter from 'utils/deleteUrlParameter';

import rotateAtiAdv from 'utils/userdata/rotateAtiAdv';
import { useStores } from 'hooks/useStores';
import texts from 'constants/texts';
import logo from 'icons/img/logo.png';
import PageContainer from 'generic/PageContainer';
import Search from './components/Search';
import SearchResult from './components/SearchResult';
import { Title } from '../../globalStyles';
import ToFormButton from './components/Search/components/ToFormButton';

import { CabinetAndFormButtonContainer } from './MainPageStyles';

const MainPage = observer((props) => {
  const {
    pagesStore: { setCurrentPage },
    findTrucksStore: { pagination, searchState, getTrucksResults, isFormQsExists, setQueryParams },
    favoritesStore: { setPopoverHintFavoriteVisible },
  } = useStores();

  const searchResultRef = useRef(null);

  useLayoutEffect(() => {
    setQueryParams();
    isFormQsExists();
  }, []);

  /**
   * Обновление QS для пагинации
   */
  useEffect(() => {
    if (pagination.page > 1) {
      setUrlParameter('page', pagination.page);
    } else {
      deleteUrlParameter('page');
    }
  }, [pagination.page]);

  /**
   * Поиск объявлений со скроллом к началу списка
   */
  const updateAdvertsWithScroll = async () => {
    await getTrucksResults();
    if (searchResultRef.current && pagination.isChanged) {
      window.scrollTo(0, searchResultRef.current.offsetTop);
    }
  };

  useEffect(() => {
    updateAdvertsWithScroll();
  }, [pagination.limit, pagination.page]);

  useEffect(() => {
    setCurrentPage('search');
    return () => {
      setCurrentPage('');
    };
  }, []);

  useEffect(() => {
    if (searchState.isSuccess) {
      rotateAtiAdv();
    }
  }, [searchState.state]);

  useEffect(() => {
    return () => setPopoverHintFavoriteVisible(false);
  }, []);

  const params = new URLSearchParams(window.location.search);
  const page = params.get('page');
  const isFormValue = [...params.keys()].length > 0;

  // TODO make it better
  const renderRobots = () => {
    if (isFormValue && [...params.keys()].length === 1 && !!page) {
      return null;
    }

    if (isFormValue || pagination.limit > 10 || (isFormValue && page)) {
      return <meta name="robots" content="noindex, follow" />;
    }

    return null;
  };

  return (
    <PageContainer page="search">
      <Helmet>
        {renderRobots()}
        <title>{texts.meta.title}</title>
        <meta
          name="description"
          content={texts.functions.getFullDescription(pagination.countAdverts)}
        />
        <meta property="og:title" content={texts.meta.title} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://tm.${getEnvironDomain()}`} />
        <meta property="og:site_name" content={texts.meta.title} />
        <meta
          property="og:description"
          content={texts.functions.getFullDescription(pagination.countAdverts)}
        />
        <meta property="og:image" content={logo} />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="300" />
        <meta property="og:url" content={`https://tm.${getEnvironDomain()}/trucks`} />
        {Number(page) >= 2 && (
          <link rel="canonical" href={`https://tm.${getEnvironDomain()}/trucks`} />
        )}
        <script type="application/ld+json">{`
            {
            "@context": "https://schema.org/",
            "@type": "Product",
             "name": "${texts.meta.title}",
             "brand": "ATI.SU",
             "url": "https://tm.${getEnvironDomain()}/",
             "logo": "https://files.${getEnvironDomain()}/Images/ati-logo-mobile-en.svg",
             "image": "https://files.${getEnvironDomain()}/assets/shared/img/big_logo_new.svg",
             "description": "${texts.meta.description}",
             "aggregateRating": {
             "@type": "AggregateRating",
             "ratingValue": "4,9",
             "reviewCount": "795"
             }
          }
        `}</script>
      </Helmet>
      <Title>
        <span className="header">Тракмаркет</span>
        <span className="description">{texts.meta.h1}</span>
      </Title>

      <CabinetAndFormButtonContainer>
        <ToFormButton path={props} />
      </CabinetAndFormButtonContainer>

      <Search {...props} />
      <div ref={searchResultRef}>
        <SearchResult />
      </div>
    </PageContainer>
  );
});

export default MainPage;
